import React from "react";
import LogoutIcon from "@mui/icons-material/Logout";
import "./UserNavlinks.css";

const UserNavlinks = ({ NavLink, userLinks, menuSource, handleLogout, toggleSidebar }) => {
  console.log("toggleSidebar", toggleSidebar);

  return (
    <div className="nav-links" data-menu-source={menuSource}>
      {userLinks.map((link) => {
        const { text, path, id, icon } = link;

        return (
          <NavLink
            to={path}
            key={id}
            className={({ isActive }) =>
              isActive ? "active nav-link" : "nav-link"
            }
            onClick={toggleSidebar}
          >
            <span style={{ marginLeft: "-20px", paddingRight: "15px" }}>
              {icon}
            </span>
            {text}
          </NavLink>
        );
      })}
      <button
        style={{ background: "none", border: "none", cursor: "pointer" }}
        className="nav-link"
        onClick={handleLogout}
      >
        <span style={{ marginLeft: "-20px", paddingRight: "15px" }}>
          <LogoutIcon />
        </span>
        Logout
      </button>
    </div>
  );
};
export default UserNavlinks;
